import { Routes, Route, Navigate } from 'react-router-dom'
import { AdminAuthProvider, useAdminAuth } from './hooks/useAdminAuth.jsx'
import AdminLogin from './components/AdminLogin'
import AdminDashboard from './components/AdminDashboard'
import ForgotPassword from './components/auth/ForgotPassword.jsx'
import ResetPassword from './components/auth/ResetPassword.jsx'
import ChangePassword from './components/auth/ChangePassword.jsx'

const AdminAppContent = () => {
  const { isAuthenticated, isLoading } = useAdminAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification de la session...</p>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      {/* Public routes (no auth required) */}
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Protected routes */}
      {isAuthenticated ? (
        <>
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/*" element={<AdminDashboard />} />
        </>
      ) : (
        <>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/*" element={<AdminLogin />} />
        </>
      )}
    </Routes>
  )
}

const AdminApp = () => {
  return (
    <AdminAuthProvider>
      <AdminAppContent />
    </AdminAuthProvider>
  )
}

export default AdminApp
